'use strict';

class SmartSearch {

    go(form) {

        let elements = form.elements;
        let weight = elements['weight'].value;
        let height = elements['height'].value;
        let terrain = elements['terrain'].value;

        let params = {};

        let res = '';
        res = weight.match(/^([<>])(\d+)$/);

        if (res) {
            if (res[1] === '<')
                params['weight_less'] = res[2];
            else if (res[1] === '>')
                params['weight_more'] = res[2];
        }

        res = height.match(/^([<>])(\d+)$/);

        if (res) {
            if (res[1] === '<')
                params['height_less'] = res[2];
            else if (res[1] === '>')
                params['height_more'] = res[2];
        }

        if (terrain)
            params['terrains[]'] = terrain;

        if (Object.keys(params).length) {
            let queryString = Object.keys(params)
                .map(key => key + '=' + params[key])
                .join('&');
            window.location.href = `/smart-search?${queryString}`;
        } else {
            window.location.href = '/smart-search'
        }

    }

}

const smartSearch = new SmartSearch();
